import RougenaResource from "./rougena.resource";

const rougenaModule = angular
  .module("app.resources.rougena", [])
  .service("Rougena", RougenaResource);

export default rougenaModule;



// WEBPACK FOOTER //
// ./src/resources/rougena/rougena.module.js